export var NetworkEventName;
(function (NetworkEventName) {
    NetworkEventName["ON_STROKE_ADDED"] = "stroke_added";
})(NetworkEventName || (NetworkEventName = {}));
export var TransferModeEnum;
(function (TransferModeEnum) {
    TransferModeEnum["PER_DOT"] = "per_dot";
    TransferModeEnum["PER_STROKE"] = "per_stroke";
})(TransferModeEnum || (TransferModeEnum = {}));
//# sourceMappingURL=PacketDataTypes.js.map